// src/components/Layout/BlankOutletWrapper.js
import React, { useMemo, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import useDynamicModules from "../useDynamicModules";

const BlankOutletWrapper = () => {
  const { modules = [] } = useDynamicModules();
  const location = useLocation();
  const navigate = useNavigate();
  const [manuallyClosed, setManuallyClosed] = useState(false);

  const isDashboard = useMemo(
    () => /\/(admin|hotels)\/dashboard(\/|$)/i.test(location.pathname),
    [location.pathname]
  );

  // show when new user has 0 or 1 module (usually just Administration)
  const showWelcome = isDashboard && modules.length <= 1 && !manuallyClosed;

  return (
    <>
      <Outlet />

      {showWelcome && (
        <div
          style={{
            marginTop: "80px",
            textAlign: "center",
            opacity: 0.9,
            border: "1px solid #ccc",
            padding: "24px",
            borderRadius: "10px",
            marginInline: "10%",
            background: "#f9f9f9",
            position: "relative",
          }}
        >
          <button
            onClick={() => setManuallyClosed(true)}
            style={{
              position: "absolute",
              top: 10,
              right: 10,
              background: "transparent",
              border: "none",
              fontSize: "20px",
              cursor: "pointer",
            }}
            title="Close welcome"
          >
            ×
          </button>

          <h2>Welcome to HMS</h2>
          <p>
            You’re just a few steps away from launching your hotel. Begin by setting up your hotel profile and assigning
            modules.
            <br />
            Need help? Reach out to our support team anytime.
          </p>

          <button
            style={{
              marginTop: "20px",
              padding: "10px 20px",
              fontSize: "16px",
              backgroundColor: "#5A4FCF",
              color: "#fff",
              border: "none",
              borderRadius: "6px",
              cursor: "pointer",
            }}
            onClick={() => navigate("/hotels/moduleassignment")}
          >
            Go to Module Assignment
          </button>
        </div>
      )}
    </>
  );
};

export default BlankOutletWrapper;
